import { Component, input, output } from '@angular/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-information-heading',
  imports: [],
  templateUrl: './onyx-information-heading.component.html',
  styleUrl: './onyx-information-heading.component.scss',
})
export class OnyxInformationHeadingComponent {
  public readonly count = input<number>();
  public readonly identifierColor = input<OnyxColor | null>();
  public readonly clickable = input(false);
  public readonly align = input<'baseline' | 'center'>('baseline');

  protected readonly linkClick = output<void>();
}
